import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';

import { fileDownload } from 'lib/commonLib';

import Icon from 'components/atoms/Icon';
import MbTooltip from 'components/atoms/MbTooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 25,
    borderRadius: '4px',
    border: `solid 1px ${theme.palette.box.secondaryBorderColor}`,
  },
  noTopMargin: { marginTop: '0 !important' },
  bar: {
    display: 'flex',
    height: '35px',
    alignItems: 'center',
    '&.open': {
      borderBottom: `solid 1px ${theme.palette.box.secondaryBorderColor}`,
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '19px',
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.common.black,
    cursor: 'pointer',
    '& > p': { margin: 0, marginRight: 5 },
  },
  graphButtonWrap: { display: 'flex', height: '100%', marginLeft: 'auto' },
  button: { minWidth: '49px', borderRadius: 0, height: 'calc(100% + 1px)' },
  expandButton: {
    borderLeft: `solid 1px ${theme.palette.box.secondaryBorderColor}`,
    '&.open': { borderBottom: '1px solid #fff' },
  },
  icon: {
    transition: 'all ease 0.4s',
    '&.open': { transform: 'rotate( -180deg )' },
  },
  content: {
    display: 'none',
    position: 'relative',
    height: 'calc(100% - 45px)',
    minHeight: 50,
    padding: 20,
    boxSizing: 'border-box',
    '&.open': { display: 'block' },
  },
  toolTip: { height: 'calc(100% + 1px)' },
}));

const SwitchingArea = ({
  title,
  handleRefesh,
  children,
  noTopMargin,
  isOpen = true,
  noneReset = false,
  hasExcel,
  dataReqPromise,
  params,
  type,
}) => {
  const { t } = useTranslation();

  const classes = useStyles();
  const [open, setOpen] = useState(isOpen);

  /**
   * 열고 닫기 버튼
   */
  const handleExpendBttonClick = () => {
    setOpen(!open);
  };

  /**
   * 엑셀 다운로드
   */
  const handleExcelDonload = () => {
    dataReqPromise({ ...params, excel: 1, type }).then((response) => {
      fileDownload(response);
    });
  };

  return (
    <div
      className={clsx(
        `mb-SwitchingArea`,
        classes.root,
        noTopMargin ? classes.noTopMargin : ''
      )}
    >
      <div className={clsx(classes.bar, { open })}>
        <div className={classes.label}>{title}</div>
        <div className={classes.graphButtonWrap}>
          {hasExcel && (
            <MbTooltip title={t('엑셀 다운로드')}>
              <IconButton
                aria-label={t('엑셀 다운로드')}
                onClick={handleExcelDonload}
              >
                <GetAppIcon />
              </IconButton>
            </MbTooltip>
          )}
          {noneReset === true && (
            <MbTooltip
              title={t('초기화')}
              className={classes.toolTip}
              placement="right-start"
            >
              <Button className={classes.button} onClick={handleRefesh}>
                <Icon icon="faUndo" color="#4d5059" />
              </Button>
            </MbTooltip>
          )}

          <MbTooltip
            title={open ? '닫기' : '펼치기'}
            className={classes.toolTip}
            placement="right-start"
          >
            <Button
              className={clsx(classes.button, classes.expandButton, {
                open,
              })}
              onClick={handleExpendBttonClick}
            >
              <Icon
                className={clsx(classes.icon, { open })}
                icon="faChevronDown"
                color="#4d5059"
              />
            </Button>
          </MbTooltip>
        </div>
      </div>
      <div className={clsx(classes.content, { open })}>{children}</div>
    </div>
  );
};

export default SwitchingArea;
